export default __webpack_public_path__ + "static/63810-001b09321985ba46739c44906d9e1136.jpg";